/** data-testid used for quickly finding elements on automated tests */
/** data-test-id comes from external library. Naming convention not followed.*/
export const qaLabelTestSites = {
    tableBody: 'site--list',
    tableRow: 'sites--row',
    addNewSiteButton: 'site--add-site-button',
    addSiteModal: {
        nameInput: 'site--add-modal--name-input',
        phoneRow: 'site--add-modal--telephone-row',
        phoneInput: '[data-test-id=src_reacttelephoneinput_test_id_5]',
        groupRow: 'site--add-modal--group-dropdown',
        autoDispatchToggle: 'site--add-modal--autodispatch-toggle',
        autoDispatcherRow: 'site--add-modal--autodispatch-row',
        campaignRow: 'site--add-modal--campaign-row',
        jobTemplateRow: 'site--add-modal--job-template-row',
        addressRow: 'site--add-modal--address-row',
        radiusInput: 'site--add-modal--radius-input',
        siteInstructionsInput: 'site--add-modal--site-instructions-input',
        externalIdInput: 'site--add-modal--external-id-input',
        /** These are modal common buttons*/
        nextButton: 'site--add-modal--next-button',
        cancelButton: 'site--add-modal--cancel-button',
        saveSiteButton: 'site--add-modal--save-button',
        /** React elements. It does not have data-test-id label.*/
        advanceTab: 'Advance',
        locationTab: 'Location'
    },
    editSiteModal: {
        /** Some buttons are different for site edition */
        id: 'sites--edit-modal--id',
        cancelButton: 'site--edit-modal--cancel-button',
        saveSiteButton: 'site--edit-modal--save-button',
        /** React element. It does not have data-test-id label. Appears only for site edition  */
        toolsTab: 'Tools',
        jobRequestGenerateButton: 'site--edit-modal--tools-bar--job-request-form--generate-button',
        jobRequestLabel: 'site--edit-modal--tools-bar--job-request-form--label',
        jobRequestText: 'site--edit-modal--tools-bar--job-request-form--text',
        liveSiteViewGenerateButton: 'site--edit-modal--tools-bar--live-site-view--generate-button',
        externalId: 'site--edit-modal--external-id',
        liveSiteViewLabel: 'site--edit-modal--tools-bar--live-site-view--label',
        liveSiteViewText: 'site--edit-modal--tools-bar--live-site-view--text',
        linkModal: {
            jobRequestText: 'site--edit-modal--tools-bar--generate--job-request-modal--text',
            liveSiteViewText: 'site--edit-modal--tools-bar--generate--job-request-modal--text',
            linkInput: 'site--edit-modal--tools-bar--generate-link-input',
            copyLinkBtn: 'site--edit-modal--tools-bar--generate-copy-btn',
            closeBtn: 'site--edit-modal--tools-bar--close-btn'
        },
        jobRequestModal: {
            text: 'site--edit-modal--tools-bar--job-request-modal--text',
            linkInput: 'site--edit-modal--tools-bar--job-request-modal--link-input',
            copyLinkBtn: 'site--edit-modal--tools-bar--job-request-modal--copy-btn',
            closeBtn: 'site--edit-modal--tools-bar--job-request-modal--close-btn'
        },
        deleteSiteButton: 'site--edit-modal--delete-button'
    }
};
